import { useState, useEffect, useMemo, useCallback } from "react";
import { GradientButton } from "../../../common/ui/Button";
import Header from "../../../common/layout/Header";

import { useNavigate } from 'react-router-dom';
import MouseParallax from "../../../common/animations/MouseParallax";

function HeroSection() {
    const navigate = useNavigate();

    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleBlast = () => {
            setTimeout(() => setIsVisible(true), 500);
        };
        window.addEventListener('nn-blasted', handleBlast);
        return () => window.removeEventListener('nn-blasted', handleBlast);
    }, []);

    // Memoised — only recalculates when isVisible changes
    const heroContentClass = useMemo(() => (
        `relative z-10 flex flex-col items-center justify-center text-center px-2 md:px-24 min-h-[calc(100vh-150px)] transition-all duration-1000 transform
        ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`
    ), [isVisible]);

    // Stable callback — never recreated across renders
    const handleAboutClick = useCallback(() => {
        navigate('/contact-us');
    }, [navigate]);

    return (
        <section className="relative w-full pb-12 min-h-screen overflow-visible" id="start" style={{ paddingTop: '0px', paddingBottom: '20px', scrollMarginTop: '120px' }}>

            {/* Navigation */}
            <Header />

            {/* Hero Content */}
            <div className={heroContentClass}>
                <MouseParallax strength={30} className="flex flex-col items-center w-full">
                    <h1 className="hero-text text-4xl sm:text-5xl md:text-5xl lg:text-[68px] leading-[1.1] max-w-5xl font-bold mx-auto text-center">
                        <span className="hero-text block relative hero-title-glow bg-gradient-to-r from-white via-blue-100 to-white bg-clip-text text-transparent">
                            Let's transform your ideas
                        </span>
                        <span className="hero-text block relative mt-2 hero-title-glow bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
                            into powerful digital
                        </span>
                        <span className="hero-text block relative mt-2 hero-title-glow bg-gradient-to-r from-white via-blue-100 to-white bg-clip-text text-transparent">
                            solutions today
                        </span>
                    </h1>
                </MouseParallax>

                <div className="mt-16 hero-text relative mx-auto text-center group">
                    <div className="absolute -inset-4 blur-2xl opacity-0 group-hover:opacity-30 bg-gradient-to-r from-cyan-500 to-blue-600 transition-opacity duration-500 rounded-full" />
                    <div className="relative">
                        <GradientButton onClick={handleAboutClick}>
                            Lets Get Started
                        </GradientButton>
                    </div>
                </div>
            </div>

        </section>
    );
}

export default HeroSection;